import { blueprintKitchenData8 } from './blueprint-kitchen-data-8';

export const blueprintData8 = {
	id: '',
	email: '',
	submissionDate: '',
	submissionId: null,
	schemaVersion: 8,
	thumbnail: '',
	metadata: {
		estimateNumber: '',
		invoiceNumber: '',
		workorderNumber: '',
		paymentStatus: 'Not Paid'
	},
	kitchens: {
		children: [] as (typeof blueprintKitchenData8)[]
	}
}
